// Model.js
// -----------------------
// @module Case
define("NVT.AnnualApplicationFormE.AnnualApplicationFormE.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/AnnualApplicationFormE/SuiteScript2/AnnualApplicationFormE.Service.ss"
            ),
            true
        )
});
});
